
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import React from "react";
import UserLookupSelect from './UserLookupSelect';

const styles = theme => ({
  chip: {
    margin: theme.spacing(1),
  }
});

class UserLookup extends React.Component {


  render() {
    const { selectedUser, placeHolder, usersToExclude = [], searchMethod = 'searchActiveDirectory' } = this.props;
    
    return (
      <div className={selectedUser ? "" : "full-width"}>
        {!selectedUser &&
          <UserLookupSelect
            usersToExclude={usersToExclude}
            searchMethod={searchMethod}
            onUserSelected={(user) => this.props.onUserSelected(user)}
            placeHolder={placeHolder}
          />
        }
        {selectedUser &&
              <Chip
              avatar={selectedUser.bun ? <Avatar src={`/api/users/userImage?bun=${selectedUser.bun}`}/> : null}
              onDelete={() => this.props.onUserSelected(null)}
              className="chip"
              label={selectedUser.name ? selectedUser.name : selectedUser.displayName}
              variant="outlined"
            />
        }
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(UserLookup);
